import React from 'react';
import { BrandLogo, ButtonV2, Group, GroupItem } from '@arc-ui/components';
import { EeIconMenu, EeIconUser2 } from '@arc-ui/icons';
import { SideBar } from '../../molecules/SideBar/SideBar';
import { EEBHeaderSmallDevicesProps } from '../../../types/ee-header';
import { useHeaderContext } from '../../../contexts';
import { ROUTES } from '../../../constants';

const EEBHeaderSmallDevices: React.FC<EEBHeaderSmallDevicesProps> = ({
  menuOpen,
  onOpenMenu,
  onCloseMenu,
  searchTriggerEl,
  basketEl,
}) => {
  const { logInLinkUrl, logInLinkTitle } = useHeaderContext();
  return (
    <>
      <SideBar open={menuOpen} onClose={onCloseMenu} />
      <div className="nav-items">
        <Group growEqual noWrap>
          <GroupItem>
            <div className="eeb-action">
              <ButtonV2
                type="button"
                buttonStyle="compact"
                ariaLabel="Open menu"
                icon={EeIconMenu}
                size="m"
                onClick={onOpenMenu}
              />
            </div>
          </GroupItem>
          <GroupItem>
            <div className="eeb-action">{basketEl}</div>
          </GroupItem>
          <GroupItem>
            <div className="eeb-action">
              <a href={`${ROUTES.SEARCH}/`} aria-label="go to home">
                <BrandLogo color="auto" subBrand="ee" />
              </a>
            </div>
          </GroupItem>
          <GroupItem>
            <div className="eeb-action">{searchTriggerEl}</div>
          </GroupItem>
          <GroupItem>
            <div className="eeb-action">
              <ButtonV2
                type="button"
                icon={EeIconUser2}
                buttonStyle="compact"
                ariaLabel={logInLinkTitle || 'Log in'}
                size="m"
                onClick={() => {
                  if (logInLinkUrl) {
                    try {
                      if (logInLinkUrl.startsWith('/')) {
                        window.location.href = logInLinkUrl;
                      } else {
                        const url = new URL(
                          logInLinkUrl,
                          window.location.origin,
                        );
                        if (url.origin === window.location.origin) {
                          window.location.href = logInLinkUrl;
                        }
                      }
                    } catch {
                      // Invalid URL, do nothing
                    }
                  }
                }}
              />
            </div>
          </GroupItem>
        </Group>
      </div>
    </>
  );
};

export default EEBHeaderSmallDevices;
